// extracted by mini-css-extract-plugin
export default {"customFont":"style_customFont__lh77p"};